

function reducer(state, action) {
  switch (action.type) {
    case "set-user":
      return {...state, user: action.payload}
    case "unset-user": {
      return {...state, user: {}}
    }
    default:
      break;
  }
}

export default reducer;